<div class="container">
    <div class="header">Verify Your Location</div>
    <div class="qr-location-why">To use the desktop client, we must verify your location through the SOPO mobile app.</div>
    <div class="instruction">Scan this QR code using your phone's camera, or use the QR scanner in the SOPO app under Profile <ion-icon name="desktop-outline"></ion-icon>.</div>

    <div class="qr-code-wrapper" *ngIf="status === 'waiting'">
        <qrcode
            [qrdata]="qrData"
            [width]="256"
            errorCorrectionLevel="H"
            colorDark="#1a1a1a"
            colorLight="#ffffff"
        ></qrcode>
        <div class="qr-logo">
            <img src="assets/icon/sopo-diamond-logo.webp" alt="SOPO" />
        </div>
    </div>

    <div class="status-message success" *ngIf="status === 'approved'">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        <span>Location verified!</span>
    </div>

    <ion-button *ngIf="status === 'approved'" shape="round" (click)="close()">
        <span>Close</span>
    </ion-button>
</div>
